import axios from "axios";

export default class CotizacionesService {
  allCotizaciones(page = 1, limit = 10, search = '', sortField = 'id', sortOrder = -1) {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "cotizaciones/todas", {
      params: { page, limit, search, sortField, sortOrder }
    });
  }
  cotizacionesDeUnMedico(id) {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "cotizaciones/medico/" + id);
  }
  crearCotizacion(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "cotizaciones/create", data);
  }

  misCotizaciones() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "cotizaciones/mias");
  }

  downloadCotizacionConId(id,locale) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "cotizaciones/descargacotizacion/"+locale,{id},{
      responseType: "blob"
    });
  }

  eliminarPorAdmin(id) {
    return axios.delete(process.env.VUE_APP_API_PUBLIC + "cotizaciones/admin/"+id);
  }



/*   cambiarEstadoDeCotizacion(data) {
    return axios.put(process.env.VUE_APP_API_PUBLIC + "cotizaciones/update", data);
  } */
}
